import { render, staticRenderFns } from "./CrmRelative.vue?vue&type=template&id=003f310e&scoped=true&"
import script from "./CrmRelative.vue?vue&type=script&lang=js&"
export * from "./CrmRelative.vue?vue&type=script&lang=js&"
import style0 from "./CrmRelative.vue?vue&type=style&index=0&id=003f310e&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "003f310e",
  null
  
)

component.options.__file = "CrmRelative.vue"
export default component.exports